import React from "react";
import image from "../../images/hero_community.jpg";
import MainFeaturedPost from "../../components/ImageComponent/MainFeaturedPost";
import SolutionsLayout from "../../layouts/SolutionsLayout";
import { Container } from "@material-ui/core";
import ProductsList from "../../components/ProductsList";
import { communityData } from "../../data/community";
import endImage from "../../images/community/community-end-hero.jpg";

const CommunityPage = () => {
	return (
		<SolutionsLayout title="Collaborate w/ other creators, get help, or just report a bug | Community | Unity">
			<MainFeaturedPost
				post={{
					title: "Community",
					description: `Join the largest community of Unity users. Creators of all types – beginner to expert, hobbyist to pro – connect here to learn, share, and inspire.`,
					image: image,
					imgText: "main image description",
				}}
			/>
			<Container>
				<ProductsList md={6} data={communityData} />
			</Container>
			<Container style={{ paddingTop: "64px", paddingBottom: "64px" }}>
				<MainFeaturedPost
					post={{
						title: "Sign up for Unity newsletters",
						description: `From webinars and blog posts, to real-world insight from across industries, our newsletters strive to bring you the latest from around the world of Unity. Subscribe to get the latest news, tutorials and offers delivered directly to your inbox.`,
						image: endImage,
						imgText: "main image description",
						buttonText: "Sign up today",
					}}
				/>
			</Container>
		</SolutionsLayout>
	);
};
export default CommunityPage;
